<template>
    <div class="team-fraction">
        <show-lx-record ref="lxRecord">
            {{$t('teamFraction.CKCJ')}}
            <div class="header-center" slot="header-center">
                <img src="@/assets/image/team-left.png" @click="()=>{toolgTeam('prev')}">
                <span>{{ titleData.curTeamName }}</span>
                <img src="@/assets/image/team-right.png" @click="()=>{toolgTeam('next')}">
            </div>
        </show-lx-record>
    </div>
</template>
<script>
import showLxRecord from '@/views/showLxRecord/showLxRecord'
export default {
    name: 'teamFraction',
    data(){
        return{
            titleData: {}
        }
    },
    components: {
        showLxRecord
    },
    methods:{
        toolgTeam(type){
            let curTeamIndex = this.titleData.teamList.findIndex(item=>item.teamId === this.titleData.curTeamId)
            let trueData = this.titleData.teamList.map((item, index)=>{
                return item.scoreSortList.length ? index : 'null'
            }).filter(item=>item!=='null')
            curTeamIndex = trueData.findIndex(item=>item===curTeamIndex)

            if(type === 'prev'){
                if(trueData[curTeamIndex] === 0){
                    // 当前是第一个
                    this.$notify({ title: this.$t('teamFraction.CZ'), message: this.$t('teamFraction.DQSDYGTD'), type: 'warning' });
                    return false
                }else{
                    let { teamId, teamName, scoreSortList } = this.titleData.teamList[trueData[curTeamIndex-1]]
                    if(scoreSortList.length){
                        this.titleData.curTeamId = teamId
                        this.titleData.curTeamName = teamName
                        this.titleData.curScoreSortList = scoreSortList
                    }else{
                        this.$notify({ title: this.$t('teamFraction.CZ'), message: this.$t('teamFraction.CWQHTDMYXLJL'), type: 'error' });
                        return false
                    }
                }
            }else{
                if((trueData.length - 1) === curTeamIndex){
                    // 当前是最后一个
                    this.$notify({ title: this.$t('teamFraction.CZ'), message: this.$t('teamFraction.CWZSZHYGTD'), type: 'warning' });
                    return false
                }else{
                    let { teamId, teamName, scoreSortList } = this.titleData.teamList[trueData[curTeamIndex+1]]
                    
                     if(scoreSortList.length){
                        this.titleData.curTeamId = teamId
                        this.titleData.curTeamName = teamName
                        this.titleData.curScoreSortList = scoreSortList
                    }else{
                        this.$notify({ title: this.$t('teamFraction.CZ'), message: this.$t('teamFraction.CWQHTDMYLXJL'), type: 'warning' });
                        return false
                    }
                }
            }
            this.$refs['lxRecord'].toolgTeam()
        }
    }
}
</script>
<style lang="scss" scoped>
.header-center{
    font-size: 18px;
    font-family: Hiragino Sans GB;
    font-weight: normal;
    color: #0D141E;
    display: flex;
    img{
        height: 24px;
        width: 24px;
    }
    img:hover{
        opacity: 0.7;
        cursor: pointer;
    }
    span{
        margin: 0 24px;
    }
}
</style>